"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelatedEntitiesQueryBuilderPlugin = exports.RelatedEntitiesQueryBuilder = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const QueryBuilderContext_1 = require("../QueryBuilderContext");
const JoinSelector_1 = __importDefault(require("../selectors/JoinSelector"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledDiv = styled_components_1.default.div `
  .row {
    margin: 4px 0;
  }
`;
const RelatedEntitiesQueryBuilder = () => {
    var _a, _b;
    const { queryManager } = (0, QueryBuilderContext_1.useQueryBuilderContext)();
    const [query, setQuery] = (0, react_1.useState)(queryManager.query);
    (0, react_1.useEffect)(() => {
        const handleChange = () => {
            console.log('RelatedEntitiesQueryBuilder handleChange');
            setQuery(Object.assign({}, queryManager.query));
        };
        handleChange();
        queryManager.subscribe('change', handleChange);
        return () => {
            queryManager.unsubscribe('change', handleChange);
        };
    }, [queryManager]);
    return (react_1.default.createElement(StyledDiv, null, (_b = (_a = query.config) === null || _a === void 0 ? void 0 : _a.joinAttributes) === null || _b === void 0 ? void 0 :
        _b.map((joinAttribute, index) => (react_1.default.createElement("div", { className: 'row', key: index },
            react_1.default.createElement(JoinSelector_1.default, { index: index, joinAttribute: joinAttribute })))),
        react_1.default.createElement("div", { className: 'row' },
            react_1.default.createElement(core_1.Button, { size: 'small', variant: 'outlined', endIcon: react_1.default.createElement(core_1.Icon, null, "add"), onClick: () => {
                    queryManager.addJoin({ direction: 'LEFT' });
                } }, "Add Join"))));
};
exports.RelatedEntitiesQueryBuilder = RelatedEntitiesQueryBuilder;
exports.RelatedEntitiesQueryBuilderPlugin = {
    name: 'Related Entities',
    type: 'RelatedEntities',
    categories: [],
    component: exports.RelatedEntitiesQueryBuilder,
    conditions: [],
    deinit: queryManager => {
        var _a, _b;
        // remove all relations
        (_b = (_a = queryManager.query.config) === null || _a === void 0 ? void 0 : _a.joinAttributes) === null || _b === void 0 ? void 0 : _b.forEach((_, index) => {
            queryManager.deleteJoin(index);
        });
    }
};
//# sourceMappingURL=RelatedEntitiesQueryBuilderPlugin.js.map